var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownGrayFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "9px",
    height: "5px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -550 -476 )"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.8330078125 0.164930555555556  C 8.9443359375 0.274884259259258  9 0.405092592592591  9 0.555555555555556  C 9 0.706018518518518  8.9443359375 0.836226851851851  8.8330078125 0.946180555555556  L 4.8955078125 4.83506944444444  C 4.7841796875 4.94502314814815  4.65234375 5  4.5 5  C 4.34765625 5  4.2158203125 4.94502314814815  4.1044921875 4.83506944444444  L 0.1669921875 0.946180555555556  C 0.0556640625 0.836226851851851  0 0.706018518518518  0 0.555555555555556  C 0 0.405092592592591  0.0556640625 0.274884259259258  0.1669921875 0.164930555555556  C 0.2783203125 0.0549768518518512  0.41015625 0  0.5625 0  L 8.4375 0  C 8.58984375 0  8.7216796875 0.0549768518518512  8.8330078125 0.164930555555556  Z ",
    fillRule: "nonzero",
    fill: "#787878",
    stroke: "none",
    transform: "matrix(1 0 0 1 550 476 )"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownGrayFilled);
export default __webpack_public_path__ + "static/media/arrow-down-gray-filled.6edbdc2ceb648ce060f934f3c485a263.svg";
export { ForwardRef as ReactComponent };